
import { IdentityEvent } from '../../../common/events/identity'
import { IHashedData } from '../../tags/live-ramp'

export interface IWindow extends Window {
    fc: any,
    FCObject: any,
    pid?: string

}
declare let window: IWindow

const FULL_CONTACT_URL='https://tags.fullcontact.com/anon/fullcontact.js'

export class FullContact {
    public initialize(token='') {
        let storedPid = ''
        // Get old hashed data
        const fcHashedData = localStorage.getItem('fcHashedData')
        if(fcHashedData) {
            const storedHashedData: IHashedData = JSON.parse(fcHashedData)
            storedPid = storedHashedData.pid
        }
        if (storedPid === '') {
            window.FCObject= 'fc'
            if(!window.fc && token !== '') {
                const w = window
                // tslint:disable-next-line
                w.fc = w.fc || function() { (w.fc.q = w.fc.q || []).push(arguments) }
                const js = document.createElement('script')
                const fjs = document.getElementsByTagName('script')[0]
                js.setAttribute('id', 'fc')
                js.src = FULL_CONTACT_URL
                js.setAttribute('async', '')
                if(fjs) {
                    fjs.parentNode.insertBefore(js, fjs)
                }
            }

            /* istanbul ignore next */
            const config = {
                callback: (pid: string) => {
                    if(pid) {
                        window.pid = pid
                        document.dispatchEvent(new CustomEvent(IdentityEvent.SET_PERSON_ID, {
                            detail: {
                                pid
                            }
                        }))
                    }
                },
                forceCallback: true
            }
            window.fc('init',token, config)
        }
    }
}
